import React from 'react'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import EmbededEntityInput from '../input/embedded_entity'
import OptionSelect from 'bstrap-react-mobx-admin/new_src/input/option_select'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import RegionsInput from '../input/regions'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import moment from 'moment'

const FPVHomepageSettings = ({ store, label, record, items, disabledEntityFromBatch, ...rest }) => {
  const formHomepageSettings = ({ store, record, updateFormField, errors }) => {
    const removeContinents = val => (val.value && val.value.length > 2)
    const platform = record.has('fp_platform_code') && record.get('fp_platform_code') && record.get('fp_platform_code').toLowerCase()

    return (
      <div className='row'>
        <div className='col-sm-12 col-md-6'>
          <OptionSelect
            attr={'fp_platform_code'}
            errors={errors}
            label={store.__('platform')}
            labelattr='text'
            onChange={updateFormField}
            optionsattr='FlyPrivatePlatforms'
            optionsrecord={store.options}
            record={record}
            valueattr='value' />
          <SelectInput
            attr={'fp_category_code'}
            errors={errors}
            label={store.__('category')}
            labelattr='text'
            onChange={updateFormField}
            optionsattr='FlyprivateCategories'
            optionsrecord={store.options}
            record={record}
            valueFilterFc={v => (platform && v.value && v.value.toLowerCase().indexOf(platform))}
            valueattr='value' />
          <TextInput
            attr='homepage_order'
            errors={errors}
            label={store.__('homepage order')}
            min='1'
            onChange={updateFormField}
            record={record}
            type='number' />
          {!record.has('regions')
            ? <RegionsInput label={store.__('regions')} attr={'regions'} hideCheckbox
              record={record} onChange={updateFormField} errors={errors}
              optionsrecord={store.options} optionsattr={'Countries'} />
            : <SelectInput
              label={store.__('region')} attr={'regions'} labelattr='text' valueattr='value'
              record={record} onChange={updateFormField} errors={errors}
              optionsrecord={store.options} optionsattr={'Countries'}
              valueFilterFc={removeContinents} />
          }
        </div>
        <div className='col-sm-12 col-md-6'>
          <DateInput label={store.__('valid from')} attr={'valid_from'} record={record}
            onChange={updateFormField} errors={errors} minDate={moment()} />
          <DateInput label={store.__('valid to')} attr={'valid_to'} record={record}
            onChange={updateFormField} errors={errors} minDate={moment()} />
        </div>
        <div className='col-sm-12'>
          <div className='alert alert-dismissible alert-warning'>
            <p><strong>{store.__('WARNING').concat(': ')}</strong>
              {store.__('Multiple regions will be divided into the separate items.')}
            </p>
          </div>
        </div>
      </div>
    )
  }

  const attr = 'flyprivate_homepage_settings'
  const toSave = (saved, data) => {
    saved.updated = new Date()
    if (data !== null) {
      Object.assign(data, saved)
    } else {
      saved.regions.split(',').map(i => {
        i && (items || store.cv.record.get(attr)).push(Object.assign(saved, { regions: i }))
      })
    }
    return saved
  }
  return (
    <EmbededEntityInput
      {...rest}
      attr={attr}
      disabledEntityFromBatch={!!disabledEntityFromBatch}
      add_title={store.__('Add homepage settings')}
      edit_title={store.__('Edit homepage settings')}
      errors={store.cv.errors}
      items={store.cv.record.get(attr)}
      label={store.__('Homepage settings')}
      onAddRow={(saved) => toSave(saved, null)}
      store={store}
      fields={[
        (attr, row) => (<OptionsField
          attr={attr}
          val={row[attr]}
          options={store.options.get('FlyPrivatePlatforms')}
          labelattr='text'
          valueattr='value' />),
        (attr, row) => (<OptionsField
          attr={attr}
          val={row[attr]}
          options={store.options.get('FlyprivateCategories')}
          labelattr='text'
          valueattr='value' />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} />)
      ]}
      rowId={(row) => null}
      EditForm={formHomepageSettings}
    />
  )
}
export default FPVHomepageSettings
